import * as fromUser from './user.actions';
import { createReducer } from '@reduxjs/toolkit';
import { User } from '../models/user.model';
import { UploadStatus } from '../models/upload-status.model';
import { UserOrder } from '../models/user-order.model';

export interface IUserState {
  user: User;
  authToken: string;
  syncStatus: UploadStatus;
  organizationCode: string;
  isAuthorized: boolean;
  successAuthBackPage: string;
  isCodeSent: boolean;
  isCodeSentEarlier: boolean;
  ordersUploadStatus: UploadStatus;
  orders: UserOrder[];
}

export const initialState: IUserState = {
  user: {
    email: '',
    userName: '',
    phone: 0,
    firstName: '',
    lastName: '',
    deliveryAddresses: [],
  },
  authToken: '',
  syncStatus: UploadStatus.NO,
  organizationCode: '',
  isAuthorized: false,
  successAuthBackPage: '',
  isCodeSent: false,
  isCodeSentEarlier: false,
  ordersUploadStatus: UploadStatus.NO,
  orders: []
};

export const userReducer = createReducer(initialState, (builder) => {
  builder.addCase(fromUser.userLogoutAction, (state) => {
    return {
      ...initialState,
      organizationCode: state.organizationCode
    };
  });
  builder.addCase(fromUser.userSendCodeAction, (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        phone: action.payload.phone
      },
      organizationCode: action.payload.organizationCode,
      isCodeSent: true,
      isCodeSentEarlier: action.payload.isCodeSentEarlier,
    };
  });
  builder.addCase(fromUser.userLoginAction, (state, action) => {
    return {
      ...state,
      user: {
        ...action.payload.user,
        userName: (action.payload.user.firstName.trim() + ' ' + action.payload.user.lastName.trim()).trim(),
      },
      organizationCode: action.payload.organizationCode,
      authToken: action.payload.authToken,
      isAuthorized: true,
      isCodeSent: false,
      isCodeSentEarlier: false
    };
  });
  builder.addCase(fromUser.userAutoLoginAction, (state, action) => {
    return {
      ...state,
      user: {
        ...action.payload.user,
      },
      organizationCode: action.payload.organizationCode,
      authToken: action.payload.authToken,
      isAuthorized: action.payload.isAuthorized,
      isCodeSent: action.payload.isCodeSent,
      isCodeSentEarlier: action.payload.isCodeSentEarlier
    };
  });
  builder.addCase(fromUser.userUpdateAction, (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        ...action.payload,
        userName: (action.payload.firstName.trim() + ' ' + action.payload.lastName.trim()).trim()
      }
    };
  });

  builder.addCase(fromUser.userNeedToFetchOrdersAction, (state) => {
    return {
      ...state,
      ordersUploadStatus: UploadStatus.NO
    };
  });

  builder.addCase(fromUser.userFetchingOrdersAction, (state) => {
    return {
      ...state,
      ordersUploadStatus: UploadStatus.LOADING,
      orders: []
    };
  });

  builder.addCase(fromUser.userFetchingInfoAction, (state) => {
    return {
      ...state,
      syncStatus: UploadStatus.LOADING,
      orders: []
    };
  });

  builder.addCase(fromUser.userSaveAction, (state, action) => {
    return {
      ...state,
      syncStatus: UploadStatus.LOADED,
      user: {
        ...action.payload
      },
      orders: [],
      ordersUploadStatus: UploadStatus.NO
    };
  });

  builder.addCase(fromUser.userStoreOrdersAction, (state, action) => {
    return {
      ...state,
      ordersUploadStatus: UploadStatus.LOADED,
      orders: [
        ...action.payload
      ]
    };
  });

  builder.addCase(fromUser.userStoreUpdateOrderAction, (state, action) => {
    const updatedOrder = action.payload;

    const newOrders = state.orders.map(order => {
      if (order.id == updatedOrder.id){
        return updatedOrder;
      }
      return order;
    });

    return {
      ...state,
      // ordersUploadStatus: UploadStatus.LOADED, // TODO: тут нужно подумать над статусом загрузки конкретного заказа
      orders: newOrders
    };
  });

  builder.addCase(fromUser.userUpdateAddressesAction, (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        deliveryAddresses: [
          ...action.payload
        ]
      }
    };
  });

  builder.addCase(fromUser.userStoreAddressesAction, (state, action) => {
    return {
      ...state,
      user: {
        ...state.user,
        deliveryAddresses: [
          {
            ...action.payload
          },
          ...state.user.deliveryAddresses
        ]
      }

    };
  });

  builder.addCase(fromUser.successAuthBackPage, (state, action) => {
    return {
      ...state,
      successAuthBackPage: action.payload,
    }
  })
});
